module.exports = __webpack_public_path__ + "img/map.432dc331.png";